import { Area, SyncableStatus } from "../../../core/database/db";
import { ComponentDTO, ComponentDTOSyncable } from "../../components/models/ComponentDTO";

export interface AreaDTO {
  id?: number;
  name: string;
  identifier: string;
  updatedAt: Date;
  isApplicable?: boolean;
  components: ComponentDTO[];
  sortingOrder?: number;
  buildQualityStepScope?: number;
}

export type AreaDTOSyncable = Omit<AreaDTO, "components"> & {
  components: ComponentDTOSyncable[]
  syncStatus: SyncableStatus;
}

export const UNASSIGNED_AREA: Area = {
  id: 0,
  name: "Unassigned Room",
  zoneId: 0,
  identifier: "UNASSIGNED",
  updatedAt: new Date(),
  syncStatus: SyncableStatus.Pending
};

/** Sentinel room option that opens the Add a Room flow instead of assigning a room. */
export const ADD_NEW_ROOM_AREA: Area = {
  id: -1,
  name: "Add New Room",
  zoneId: 0,
  identifier: "ADD_NEW_ROOM",
  updatedAt: new Date(),
  syncStatus: SyncableStatus.Pending
};